export default "__VITE_ASSET__CNuZY_ex__"